import { Svg, Path } from '@react-pdf/renderer';

const ResidentTurnoverIcon: React.FC<{ width?: number; height?: number }> = ({
  width = 45,
  height = 46,
}) => (
    <Svg width={width} height={height} viewBox="0 0 45 46" fill="none">
    <Path d="M41.9882 5.13829C36.6732 -3.92586 28.7008 1.76145 28.7008 1.76145V2.11691C34.9016 1.76145 37.9134 6.56012 38.4449 7.27103L34.9016 9.22605L43.2283 12.0697L45 3.53874L41.9882 5.13829Z" fill="#C1BB00"/>
    <Path d="M6.55512 38.9067L10.0984 36.9517L1.77165 34.108L0 42.4613L3.01181 40.8617C8.32677 49.9259 16.2992 44.2385 16.2992 44.2385V44.0608C10.0984 44.4163 6.90945 39.6176 6.55512 38.9067Z" fill="#C1BB00"/>
    <Path d="M11.3386 20.6007V35.5299H32.5984V20.6007L21.9685 11.0033L11.3386 20.6007Z" fill="#C1BB00"/>
    <Path d="M31.1811 11.892V6.73785C31.1811 6.56012 31.0039 6.38239 30.6496 6.20466C30.2953 6.02694 29.7638 6.02694 29.2323 6.02694C28.7008 6.02694 28.3465 6.02694 27.815 6.20466C27.4606 6.38239 27.2835 6.38239 27.2835 6.73785V10.8256L21.9685 6.02694L5.31496 21.1339H8.32677L21.9685 9.22605L35.6102 21.1339H38.622L31.0039 14.0247V11.892H31.1811Z" fill="#C1BB00"/>
    </Svg>
);

export default ResidentTurnoverIcon;
